import { Input, Tooltip } from "antd"
import { ExclamationCircleFilled, EyeFilled, EyeInvisibleFilled } from "@ant-design/icons"
import { ERROR_RED, PURPLE } from "../../styles/styleUtils"
import { useEffect, useState, useCallback } from "react"
import { getTranslated, validateAttr } from "../../utils/CommonUtils"
import { applyROAccess } from "../../utils/ValidationUtils"
import { useSelector } from "react-redux"
import debounce from 'lodash.debounce';

/**
 * @param {*} props 
   @param {String} props.value Current password value
   @param {String} props.placeholder placeholder text 
   @param {Boolean} props.isReadOnly ReadOnly status of the field
   @param {String} props.actionMode CREATE / UPDATE access mode
   @param {String} props.access READONLY/READWRITE/RCREATE_WUPDATE/WCREATE_RUPDATE
   @param {Function} props.handleSchemaDataChange (optional) function specific to handle value change for schema-data modal 
   @param {Boolean} props.visibilityToggle To show toggle button or control password visible [true - toggle button visible by default]
 */


const PasswordField = (props) => {

  const [value, setValue] = useState(null)
  const [attrStatus, setAttrStatus] = useState("")
  const [readOnly, setReadOnly] = useState(false)

  const dict = useSelector(state => state.common.dict)

  useEffect(() => {
    setValue(props.value)
  }, [props.value])

  useEffect(() => {
    setReadOnly(props.isReadOnly || applyROAccess(props.access, props.actionMode))
  }, [props.access, props.actionMode, props.isReadOnly])

  useEffect(() => {
    if (props.validateState && value !== null) {
      setAttrStatus(validateAttr(props, value))
    }
  }, [props.validateState])

  //debounce logic to reduce number of schema change checking
  // const debouncedSchemaChange = useCallback(
  //   debounce((val) => {
  //     if (!readOnly && props.value !== val) {
  //       props.handleSchemaDataChange?.(props, val);
  //     }
  //   }, 300),
  //   [props.value, readOnly]
  // );

  const handleChange = (event) => {
    const newValue = event?.target?.value
    const status = validateAttr(props, newValue)

    setAttrStatus(status)
    setValue(newValue)
    props.handleChange && props.handleChange(newValue)
    props.handleSchemaDataChange && props.handleSchemaDataChange(props,newValue)// && debouncedSchemaChange(newValue)
  }

  const handleBlur = (event) => {
    props.handleBlur && props.handleBlur(value)
  }

  return <span className={`${attrStatus.errorMsg ? `display-flex` : ""} attr-wrap ${readOnly ? "read-only" : ""}`}>
    <Input.Password
      {...props}
      value={value}
      readOnly={readOnly}
      status={attrStatus.status}
      className={`${props.className} ${props.parentClassName}`}
      onBlur={(event) => handleBlur(event)}
      onChange={(event) => handleChange(event)}
      iconRender={(visible) => (visible ? <EyeFilled style={{ color: PURPLE }} /> : <EyeInvisibleFilled style={{ color: PURPLE }} />)}
      // visibilityToggle={props.visibilityToggle}
      tabIndex={readOnly && -1}
    />
    {attrStatus.errorMsg ? <Tooltip title={getTranslated(dict, attrStatus.errorMsg)}><ExclamationCircleFilled style={{ color: ERROR_RED, paddingLeft: "5px" }} /></Tooltip> : <></>}
  </span>
}

export default PasswordField